import { ref } from 'vue';

import { useCart } from '~/composables/use-cart';
import {
  restoreOriginalContext,
  switchToCartContext,
} from '~/lib/dynamic-yield/dynamic-yield-context-manager';
import { extractCartSkus } from '~/utils/item-cart-properties';

const isOpen = ref(false);

export function useCartDrawerVisibility() {
  const { cart } = useCart();

  /**
   * Opens the cart drawer.
   */
  const openDrawer = () => {
    isOpen.value = true;
    const cartSkus = extractCartSkus(cart.value);
    switchToCartContext(cartSkus);
  };

  /**
   * Closes the cart drawer.
   */
  const closeDrawer = () => {
    isOpen.value = false;
    restoreOriginalContext();
  };

  /**
   * Toggles the visibility of the cart drawer.
   */
  const toggleDrawer = () => {
    if (isOpen.value) {
      closeDrawer();
    } else {
      openDrawer();
    }
  };

  return {
    closeDrawer,
    isOpen, // Expose as a ref
    openDrawer,
    toggleDrawer,
  };
}
